import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link, ExternalLink } from './Link';
import { IconButton } from './Icon';

const Wrapper = styled.div`
  background: var(--banner-info-gradient);
  color: var(--banner-content);
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  padding: 12px 16px;
  font-weight: var(--bold);

  > ${IconButton} {
    color: var(--banner-content);
    height: var(--medium-large);
    margin-left: 8px;
    width: var(--medium-large);
  }

  ${ExternalLink}, ${Link} {
    color: inherit;
    font-weight: var(--bold);
    text-decoration: underline;
  }
`;
const BodyWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
`;

const Body = styled.span``;

function BaseBanner({ children, className, onDismiss, ...props }) {
  return (
    <Wrapper className={className} {...props}>
      <BodyWrapper>
        <Body>{children}</Body>
      </BodyWrapper>

      {onDismiss && (
        <IconButton icon="times" label="Dismiss banner" onClick={onDismiss} />
      )}
    </Wrapper>
  );
}

BaseBanner.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onDismiss: PropTypes.func,
};

BaseBanner.displayName = 'Banner';

const Banner = styled(BaseBanner)``;

export default Banner;

export const NegativeBanner = styled(Banner).attrs(() => ({
  role: 'alert',
  'aria-live': 'polite',
}))`
  background: var(--banner-negative-gradient);
`;

export const BannerGroup = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 2000;
`;
